import React, { useEffect } from 'react';
import { useState } from 'react';
import Preview from './Preview';
import { icons } from './settings.js';

export const context = React.createContext({
  current: 0,
  setCurrent: () => null,
  previewUrls: new Map(),
  setPreviewUrls: () => null,
  registerImage: () => null,
});

const PreviewGroup = props => {
  const { previewPrefixCls = 'ne-image-preview', children } = props;
  const [isShowPreview, setShowPreview] = useState(false);
  const [previewUrls, setPreviewUrls] = useState(new Map());
  const [current, setCurrent] = useState(0);
  const onPreviewClose = e => {
    e && e.stopPropagation();
    setShowPreview(false);
  };
  const previewUrlsKeys = Array.from(previewUrls.keys());
  const currentControlledKey = previewUrlsKeys[current];
  useEffect(() => {
    currentControlledKey && setCurrent(currentControlledKey);
  }, currentControlledKey);
  const registerImage = (currentId, src, canPreview) => {
    const unRegister = () => {
      setPreviewUrls(oldPreviewUrls => {
        const clonePreviewUrls = new Map(oldPreviewUrls);
        const deleteResult = clonePreviewUrls.delete(currentId);
        return deleteResult ? clonePreviewUrls : oldPreviewUrls;
      });
    };
    setPreviewUrls(oldPreviewUrls => {
      return new Map(oldPreviewUrls).set(currentId, {
        src,
        canPreview,
      });
    });
    return unRegister;
  };
  return (
    <context.Provider
      value={{
        isPreviewGroup: true,
        current,
        setCurrent,
        previewUrls,
        setPreviewUrls,
        registerImage,
        setShowPreview,
      }}>
      {children}
      <Preview
        prefixCls={previewPrefixCls}
        visible={isShowPreview}
        icons={icons}
        onClose={onPreviewClose}
        src={previewUrls.get(current)}></Preview>
    </context.Provider>
  );
};

export default PreviewGroup;



// WEBPACK FOOTER //
// ./src/image/PreviewGroup.jsx